module.exports = __webpack_public_path__ + "5c0e73adb9ce9595e9859fb011870177.svg";